import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useRoles from "../../hooks/custom-hooks/useRoles";
import { getUserRoles } from "../../utils/helpers";
import { defaultConsoleId, landingPathFor } from "../constants/consoles";

// Component-level role gate for v2 routes, shared by both consoles.
//
// useRoles() is called during React's render cycle rather than at router-construction
// time (which is what the legacy table does -- see the module-scope .map() in
// src/navigation/routes.jsx), so a role change is reflected on the very next render
// instead of needing a hard reload.
//
// The denial target is role-aware, and that matters: this used to be a hardcoded
// <Navigate to="/home">, but /home is registered for ADMIN/SUPER_ADMIN only and legacy
// gates by omission, so a denied pharmacist was redirected straight into NoPageFound.
// Sending them to their own default console instead means a pharmacist who opens
// /v2/ops/orders lands on /v2/pharmacy/orders.
function RequireRoles({ roles, children }) {
    const allowed = useRoles(roles);
    if (!allowed) {
        // getUserRoles(), not useRoles(): useRoles force-calls logoutHelper() when the
        // roles cookie is missing but token+user are present, which would log the user
        // out mid-render. getUserRoles just returns [] -- and [] resolves to the
        // no-access page, which is the honest destination for someone with no roles.
        const userRoles = getUserRoles();
        return <Navigate to={landingPathFor(defaultConsoleId(userRoles), userRoles)} replace />;
    }
    return children;
}

RequireRoles.propTypes = {
    roles: PropTypes.arrayOf(PropTypes.string).isRequired,
    children: PropTypes.node.isRequired,
};

export default RequireRoles;
